import style from '../index.scss';
import React from 'react';
import { Link } from 'js/components/common/Link';
import { useGameLink } from '@theme/js/hooks/swiss/useGameLink';

export const GameItem = ({ children, code }) => {
    const { fullGameLink } = useGameLink(code);

    return (
        <li className={style.itemContainer}>
            <Link className={style.item} href={fullGameLink}>
                {children}
            </Link>
        </li>
     );
};
